export default __webpack_public_path__ + "static/media/cover_video.3037707f.mp4";